// Translations for GYM BRO Mobile Webapp
// Supports: English, Spanish, Portuguese, French, German, Italian, Japanese, Korean, Chinese, Bulgarian, Romanian, Arabic, Russian

export const translations = {
    en: {
        // Header
        home: 'Home',
        features: 'Features',
        aiCoach: 'AI Coach',
        talkToAiCoach: 'Talk to AI Coach',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness & Data',
        heroTagline: 'Your AI-powered fitness companion. Get personalized advice, workout tips, and nutrition guidance — anytime.',
        startChatting: 'Start Chatting Now',
        instantAnswers: 'Instant Answers',
        personalizedPlans: 'Personalized Plans',
        
        // Features
        featuresTitle: 'Everything You Need',
        featuresSubtitle: 'Powered by advanced AI to give you the best fitness advice and support on your journey.',
        aiPoweredCoaching: 'AI-Powered Coaching',
        aiPoweredCoachingDesc: 'Get intelligent workout recommendations tailored to your goals and fitness level.',
        exerciseLibrary: 'Hub de Técnica BUNKER',
        exerciseLibraryDesc: 'Accede a vídeos creados específicamente con las máquinas del gimnasio. Optimiza cada repetición con guía experta.',
        nutritionGuidance: 'Nutrition Guidance',
        nutritionGuidanceDesc: 'Receive personalized meal suggestions and macro calculations.',
        workoutPlanning: 'Workout Planning',
        workoutPlanningDesc: 'Build structured training programs for any fitness goal.',
        availability: '24/7 Availability',
        availabilityDesc: 'Your fitness coach is always ready, day or night.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Explore BUNKER and see what each machine can do with you interactively.',
        
        // Chat
        aiPowered: 'AI-Powered',
        yourAiCoach: 'Your AI Coach',
        chatSubtitle: 'Ask anything about fitness, nutrition, workouts, or training. Get instant, personalized answers.',
        gymBroAiCoach: 'GYM BRO AI Coach',
        alwaysOnline: 'Always online • Instant responses',
        online: 'Online',
        tryAsking: 'Try asking:',
        tip1: 'Best chest exercises?',
        tip2: 'How to lose belly fat?',
        tip3: 'Protein intake tips',
        tip4: 'Beginner workout plan',
        closeChat: 'Close',
        
        // CTA
        exercises: 'Exercises',
        available: 'Available',
        potential: 'Potential',
        readyToTransform: 'Ready to Transform?',
        ctaSubtitle: 'Start your fitness journey today with your personal AI coach. No signup required — just pure, instant fitness knowledge.',
        startYourJourney: 'Start Your Journey',
        
        // Footer
        allRightsReserved: 'All rights reserved.',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
    },
    es: {
        // Header
        home: 'Inicio',
        features: 'Funciones',
        aiCoach: 'Coach IA',
        talkToAiCoach: 'Hablar con Coach IA',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness y Datos',
        heroTagline: 'Tu compañero de fitness con IA. Obtén consejos personalizados, tips de entrenamiento y guía nutricional — en cualquier momento.',
        startChatting: 'Comenzar a Chatear',
        instantAnswers: 'Respuestas Instantáneas',
        personalizedPlans: 'Planes Personalizados',
        
        // Features
        featuresTitle: 'Todo lo que Necesitas',
        featuresSubtitle: 'Impulsado por IA avanzada para darte los mejores consejos de fitness en tu camino.',
        aiPoweredCoaching: 'Coaching con IA',
        aiPoweredCoachingDesc: 'Obtén recomendaciones de entrenamiento adaptadas a tus metas y nivel de fitness.',
        exerciseLibrary: 'Hub de Técnica BUNKER',
        exerciseLibraryDesc: 'Accede a vídeos creados específicamente con las máquinas del gimnasio. Optimiza cada repetición con guía experta.',
        nutritionGuidance: 'Guía Nutricional',
        nutritionGuidanceDesc: 'Recibe sugerencias de comidas personalizadas y cálculos de macros.',
        workoutPlanning: 'Planificación de Entrenamientos',
        workoutPlanningDesc: 'Construye programas de entrenamiento estructurados para cualquier meta.',
        availability: 'Disponible 24/7',
        availabilityDesc: 'Tu coach de fitness siempre está listo, día y noche.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Recorre BUNKER y mira lo que cada máquina puede hacer contigo de forma interactiva.',
        
        // Chat
        aiPowered: 'Con IA',
        yourAiCoach: 'Tu Coach IA',
        chatSubtitle: 'Pregunta cualquier cosa sobre fitness, nutrición, entrenamientos o training. Obtén respuestas instantáneas y personalizadas.',
        gymBroAiCoach: 'GYM BRO Coach IA',
        alwaysOnline: 'Siempre online • Respuestas instantáneas',
        online: 'En línea',
        tryAsking: 'Intenta preguntar:',
        tip1: '¿Mejores ejercicios de pecho?',
        tip2: '¿Cómo perder grasa abdominal?',
        tip3: 'Consejos de proteína',
        tip4: 'Plan de entrenamiento para principiantes',
        closeChat: 'Cerrar',
        
        // CTA
        exercises: 'Ejercicios',
        available: 'Disponible',
        potential: 'Potencial',
        readyToTransform: '¿Listo para Transformarte?',
        ctaSubtitle: 'Comienza tu viaje fitness hoy con tu coach personal de IA. Sin registro — solo conocimiento fitness instantáneo.',
        startYourJourney: 'Comienza tu Viaje',
        
        // Footer
        allRightsReserved: 'Todos los derechos reservados.',
        privacyPolicy: 'Política de Privacidad',
        termsOfService: 'Términos de Servicio',
    },
    pt: {
        // Header
        home: 'Início',
        features: 'Recursos',
        aiCoach: 'Coach IA',
        talkToAiCoach: 'Falar com Coach IA',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness e Dados',
        heroTagline: 'Seu companheiro de fitness com IA. Obtenha conselhos personalizados, dicas de treino e orientação nutricional — a qualquer momento.',
        startChatting: 'Começar a Conversar',
        instantAnswers: 'Respostas Instantâneas',
        personalizedPlans: 'Planos Personalizados',
        
        // Features
        featuresTitle: 'Tudo que Você Precisa',
        featuresSubtitle: 'Alimentado por IA avançada para dar os melhores conselhos de fitness na sua jornada.',
        aiPoweredCoaching: 'Coaching com IA',
        aiPoweredCoachingDesc: 'Obtenha recomendações de treino adaptadas aos seus objetivos e nível de fitness.',
        exerciseLibrary: 'Biblioteca de Exercícios',
        exerciseLibraryDesc: 'Acesse guias detalhados de centenas de exercícios com dicas de forma correta.',
        nutritionGuidance: 'Orientação Nutricional',
        nutritionGuidanceDesc: 'Receba sugestões de refeições personalizadas e cálculos de macros.',
        workoutPlanning: 'Planejamento de Treinos',
        workoutPlanningDesc: 'Construa programas de treino estruturados para qualquer objetivo.',
        availability: 'Disponível 24/7',
        availabilityDesc: 'Seu coach de fitness está sempre pronto, dia e noite.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Explore o BUNKER e veja o que cada máquina pode fazer com você de forma interativa.',
        
        // Chat
        aiPowered: 'Com IA',
        yourAiCoach: 'Seu Coach IA',
        chatSubtitle: 'Pergunte qualquer coisa sobre fitness, nutrição, treinos. Obtenha respostas instantâneas e personalizadas.',
        gymBroAiCoach: 'GYM BRO Coach IA',
        alwaysOnline: 'Sempre online • Respostas instantâneas',
        online: 'Online',
        tryAsking: 'Tente perguntar:',
        tip1: 'Melhores exercícios de peito?',
        tip2: 'Como perder gordura abdominal?',
        tip3: 'Dicas de proteína',
        tip4: 'Plano de treino para iniciantes',
        closeChat: 'Fechar',
        
        // CTA
        exercises: 'Exercícios',
        available: 'Disponível',
        potential: 'Potencial',
        readyToTransform: 'Pronto para se Transformar?',
        ctaSubtitle: 'Comece sua jornada fitness hoje com seu coach pessoal de IA. Sem cadastro — apenas conhecimento fitness instantâneo.',
        startYourJourney: 'Comece sua Jornada',
        
        // Footer
        allRightsReserved: 'Todos os direitos reservados.',
        privacyPolicy: 'Política de Privacidade',
        termsOfService: 'Termos de Serviço',
    },
    fr: {
        // Header
        home: 'Accueil',
        features: 'Fonctionnalités',
        aiCoach: 'Coach IA',
        talkToAiCoach: 'Parler au Coach IA',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness et Données',
        heroTagline: 'Votre compagnon fitness alimenté par l\'IA. Obtenez des conseils personnalisés, des astuces d\'entraînement et des conseils nutritionnels — à tout moment.',
        startChatting: 'Commencer à Discuter',
        instantAnswers: 'Réponses Instantanées',
        personalizedPlans: 'Plans Personnalisés',
        
        // Features
        featuresTitle: 'Tout ce dont Vous Avez Besoin',
        featuresSubtitle: 'Alimenté par une IA avancée pour vous donner les meilleurs conseils fitness.',
        aiPoweredCoaching: 'Coaching par IA',
        aiPoweredCoachingDesc: 'Obtenez des recommandations d\'entraînement adaptées à vos objectifs.',
        exerciseLibrary: 'Bibliothèque d\'Exercices',
        exerciseLibraryDesc: 'Accédez à des guides détaillés pour des centaines d\'exercices.',
        nutritionGuidance: 'Conseils Nutritionnels',
        nutritionGuidanceDesc: 'Recevez des suggestions de repas personnalisées et calculs de macros.',
        workoutPlanning: 'Planification d\'Entraînement',
        workoutPlanningDesc: 'Construisez des programmes d\'entraînement structurés.',
        availability: 'Disponible 24/7',
        availabilityDesc: 'Votre coach fitness est toujours prêt, jour et nuit.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Explorez BUNKER et voyez ce que chaque machine peut faire avec vous de manière interactive.',
        
        // Chat
        aiPowered: 'Propulsé par IA',
        yourAiCoach: 'Votre Coach IA',
        chatSubtitle: 'Posez n\'importe quelle question sur le fitness, la nutrition ou l\'entraînement.',
        gymBroAiCoach: 'GYM BRO Coach IA',
        alwaysOnline: 'Toujours en ligne • Réponses instantanées',
        online: 'En ligne',
        tryAsking: 'Essayez de demander:',
        tip1: 'Meilleurs exercices pectoraux?',
        tip2: 'Comment perdre la graisse abdominale?',
        tip3: 'Conseils sur les protéines',
        tip4: 'Programme débutant',
        closeChat: 'Fermer',
        
        // CTA
        exercises: 'Exercices',
        available: 'Disponible',
        potential: 'Potentiel',
        readyToTransform: 'Prêt à vous Transformer?',
        ctaSubtitle: 'Commencez votre parcours fitness aujourd\'hui avec votre coach IA personnel.',
        startYourJourney: 'Commencez votre Parcours',
        
        // Footer
        allRightsReserved: 'Tous droits réservés.',
        privacyPolicy: 'Politique de Confidentialité',
        termsOfService: 'Conditions d\'Utilisation',
    },
    de: {
        // Header
        home: 'Startseite',
        features: 'Funktionen',
        aiCoach: 'KI-Coach',
        talkToAiCoach: 'Mit KI-Coach sprechen',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness & Daten',
        heroTagline: 'Dein KI-gestützter Fitness-Begleiter. Erhalte personalisierte Ratschläge, Trainingstipps und Ernährungsberatung — jederzeit.',
        startChatting: 'Jetzt Chatten',
        instantAnswers: 'Sofortige Antworten',
        personalizedPlans: 'Personalisierte Pläne',
        
        // Features
        featuresTitle: 'Alles was Du Brauchst',
        featuresSubtitle: 'Angetrieben von fortschrittlicher KI für die besten Fitness-Ratschläge.',
        aiPoweredCoaching: 'KI-Coaching',
        aiPoweredCoachingDesc: 'Erhalte intelligente Trainingsempfehlungen für deine Ziele.',
        exerciseLibrary: 'Übungsbibliothek',
        exerciseLibraryDesc: 'Zugang zu detaillierten Anleitungen für hunderte Übungen.',
        nutritionGuidance: 'Ernährungsberatung',
        nutritionGuidanceDesc: 'Personalisierte Mahlzeitenvorschläge und Makro-Berechnungen.',
        workoutPlanning: 'Trainingsplanung',
        workoutPlanningDesc: 'Erstelle strukturierte Trainingsprogramme für jedes Ziel.',
        availability: '24/7 Verfügbar',
        availabilityDesc: 'Dein Fitness-Coach ist immer bereit, Tag und Nacht.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Erkunde BUNKER und sieh, was jede Maschine interaktiv mit dir machen kann.',
        
        // Chat
        aiPowered: 'KI-gestützt',
        yourAiCoach: 'Dein KI-Coach',
        chatSubtitle: 'Frage alles über Fitness, Ernährung oder Training.',
        gymBroAiCoach: 'GYM BRO KI-Coach',
        alwaysOnline: 'Immer online • Sofortige Antworten',
        online: 'Online',
        tryAsking: 'Versuche zu fragen:',
        tip1: 'Beste Brustübungen?',
        tip2: 'Wie verliere ich Bauchfett?',
        tip3: 'Protein-Tipps',
        tip4: 'Anfänger-Trainingsplan',
        closeChat: 'Schließen',
        
        // CTA
        exercises: 'Übungen',
        available: 'Verfügbar',
        potential: 'Potenzial',
        readyToTransform: 'Bereit zur Transformation?',
        ctaSubtitle: 'Starte deine Fitness-Reise heute mit deinem persönlichen KI-Coach.',
        startYourJourney: 'Starte deine Reise',
        
        // Footer
        allRightsReserved: 'Alle Rechte vorbehalten.',
        privacyPolicy: 'Datenschutzrichtlinie',
        termsOfService: 'Nutzungsbedingungen',
    },
    it: {
        // Header
        home: 'Home',
        features: 'Funzionalità',
        aiCoach: 'Coach IA',
        talkToAiCoach: 'Parla con Coach IA',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness e Dati',
        heroTagline: 'Il tuo compagno fitness con IA. Ottieni consigli personalizzati, suggerimenti di allenamento e guida nutrizionale — in qualsiasi momento.',
        startChatting: 'Inizia a Chattare',
        instantAnswers: 'Risposte Istantanee',
        personalizedPlans: 'Piani Personalizzati',
        
        // Features
        featuresTitle: 'Tutto ciò di cui Hai Bisogno',
        featuresSubtitle: 'Alimentato da IA avanzata per darti i migliori consigli fitness.',
        aiPoweredCoaching: 'Coaching con IA',
        aiPoweredCoachingDesc: 'Ottieni raccomandazioni di allenamento su misura per i tuoi obiettivi.',
        exerciseLibrary: 'Libreria Esercizi',
        exerciseLibraryDesc: 'Accedi a guide dettagliate per centinaia di esercizi.',
        nutritionGuidance: 'Guida Nutrizionale',
        nutritionGuidanceDesc: 'Ricevi suggerimenti di pasti personalizzati e calcoli macro.',
        workoutPlanning: 'Pianificazione Allenamenti',
        workoutPlanningDesc: 'Costruisci programmi di allenamento strutturati.',
        availability: 'Disponibile 24/7',
        availabilityDesc: 'Il tuo coach fitness è sempre pronto, giorno e notte.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Esplora BUNKER e scopri cosa può fare ogni macchina con te in modo interattivo.',
        
        // Chat
        aiPowered: 'Con IA',
        yourAiCoach: 'Il Tuo Coach IA',
        chatSubtitle: 'Chiedi qualsiasi cosa su fitness, nutrizione o allenamento.',
        gymBroAiCoach: 'GYM BRO Coach IA',
        alwaysOnline: 'Sempre online • Risposte istantanee',
        online: 'Online',
        tryAsking: 'Prova a chiedere:',
        tip1: 'Migliori esercizi petto?',
        tip2: 'Come perdere grasso addominale?',
        tip3: 'Consigli sulle proteine',
        tip4: 'Piano allenamento principianti',
        closeChat: 'Chiudi',
        
        // CTA
        exercises: 'Esercizi',
        available: 'Disponibile',
        potential: 'Potenziale',
        readyToTransform: 'Pronto a Trasformarti?',
        ctaSubtitle: 'Inizia il tuo percorso fitness oggi con il tuo coach IA personale.',
        startYourJourney: 'Inizia il Tuo Percorso',
        
        // Footer
        allRightsReserved: 'Tutti i diritti riservati.',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Termini di Servizio',
    },
    ja: {
        // Header
        home: 'ホーム',
        features: '機能',
        aiCoach: 'AIコーチ',
        talkToAiCoach: 'AIコーチと話す',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: 'フィットネス＆データ',
        heroTagline: 'AI搭載のフィットネスパートナー。パーソナライズされたアドバイス、トレーニングのヒント、栄養ガイダンスをいつでも。',
        startChatting: 'チャットを開始',
        instantAnswers: '即座の回答',
        personalizedPlans: 'カスタムプラン',
        
        // Features
        featuresTitle: '必要なすべてが揃っています',
        featuresSubtitle: '高度なAIを活用して、最高のフィットネスアドバイスを提供します。',
        aiPoweredCoaching: 'AIコーチング',
        aiPoweredCoachingDesc: '目標に合わせたインテリジェントなワークアウト推奨を取得。',
        exerciseLibrary: 'エクササイズライブラリ',
        exerciseLibraryDesc: '数百のエクササイズの詳細ガイドにアクセス。',
        nutritionGuidance: '栄養ガイダンス',
        nutritionGuidanceDesc: 'パーソナライズされた食事提案とマクロ計算。',
        workoutPlanning: 'ワークアウト計画',
        workoutPlanningDesc: 'あらゆる目標のための構造化されたトレーニングプログラム。',
        availability: '24時間対応',
        availabilityDesc: 'フィットネスコーチはいつでも準備OK。',
        digitalTwins: 'デジタルツイン',
        digitalTwinsDesc: 'BUNKERを探索し、各マシンがあなたとインタラクティブに何ができるかを確認してください。',
        
        // Chat
        aiPowered: 'AI搭載',
        yourAiCoach: 'あなたのAIコーチ',
        chatSubtitle: 'フィットネス、栄養、トレーニングについて何でも質問してください。',
        gymBroAiCoach: 'GYM BRO AIコーチ',
        alwaysOnline: '常にオンライン • 即座の応答',
        online: 'オンライン',
        tryAsking: '質問例:',
        tip1: '胸のベストエクササイズは?',
        tip2: 'お腹の脂肪を減らすには?',
        tip3: 'プロテインのヒント',
        tip4: '初心者ワークアウトプラン',
        closeChat: '閉じる',
        
        // CTA
        exercises: 'エクササイズ',
        available: '対応',
        potential: '可能性',
        readyToTransform: '変身の準備はできましたか?',
        ctaSubtitle: 'パーソナルAIコーチと一緒に今日からフィットネスの旅を始めましょう。',
        startYourJourney: '旅を始める',
        
        // Footer
        allRightsReserved: '全著作権所有。',
        privacyPolicy: 'プライバシーポリシー',
        termsOfService: '利用規約',
    },
    ko: {
        // Header
        home: '홈',
        features: '기능',
        aiCoach: 'AI 코치',
        talkToAiCoach: 'AI 코치와 대화',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: '피트니스 & 데이터',
        heroTagline: 'AI 기반 피트니스 파트너. 맞춤형 조언, 운동 팁, 영양 가이드를 언제든지.',
        startChatting: '채팅 시작',
        instantAnswers: '즉각적인 답변',
        personalizedPlans: '맞춤 플랜',
        
        // Features
        featuresTitle: '필요한 모든 것',
        featuresSubtitle: '최고의 피트니스 조언을 위한 고급 AI로 구동됩니다.',
        aiPoweredCoaching: 'AI 코칭',
        aiPoweredCoachingDesc: '목표에 맞는 지능적인 운동 추천을 받으세요.',
        exerciseLibrary: '운동 라이브러리',
        exerciseLibraryDesc: '수백 가지 운동에 대한 상세 가이드에 액세스.',
        nutritionGuidance: '영양 가이드',
        nutritionGuidanceDesc: '맞춤형 식단 제안과 매크로 계산.',
        workoutPlanning: '운동 계획',
        workoutPlanningDesc: '모든 목표를 위한 체계적인 트레이닝 프로그램.',
        availability: '24/7 이용 가능',
        availabilityDesc: '피트니스 코치가 항상 준비되어 있습니다.',
        digitalTwins: '디지털 트윈',
        digitalTwinsDesc: 'BUNKER를 탐험하고 각 머신이 당신과 상호작용하여 무엇을 할 수 있는지 확인하세요.',
        
        // Chat
        aiPowered: 'AI 기반',
        yourAiCoach: '당신의 AI 코치',
        chatSubtitle: '피트니스, 영양, 운동에 대해 무엇이든 물어보세요.',
        gymBroAiCoach: 'GYM BRO AI 코치',
        alwaysOnline: '항상 온라인 • 즉각적인 응답',
        online: '온라인',
        tryAsking: '질문 예시:',
        tip1: '최고의 가슴 운동?',
        tip2: '뱃살 빼는 방법?',
        tip3: '단백질 섭취 팁',
        tip4: '초보자 운동 플랜',
        closeChat: '닫기',
        
        // CTA
        exercises: '운동',
        available: '이용 가능',
        potential: '잠재력',
        readyToTransform: '변신할 준비가 되셨나요?',
        ctaSubtitle: '개인 AI 코치와 함께 오늘 피트니스 여정을 시작하세요.',
        startYourJourney: '여정 시작하기',
        
        // Footer
        allRightsReserved: '모든 권리 보유.',
        privacyPolicy: '개인정보 처리방침',
        termsOfService: '이용약관',
    },
    zh: {
        // Header
        home: '首页',
        features: '功能',
        aiCoach: 'AI教练',
        talkToAiCoach: '与AI教练对话',
        
        // Hero
        gymBro: 'GYM BRO',
        fitnessAndData: '健身与数据',
        heroTagline: '您的AI健身伙伴。随时获取个性化建议、锻炼技巧和营养指导。',
        startChatting: '开始聊天',
        instantAnswers: '即时回答',
        personalizedPlans: '个性化计划',
        
        // Features
        featuresTitle: '您需要的一切',
        featuresSubtitle: '由先进AI驱动，为您提供最佳健身建议。',
        aiPoweredCoaching: 'AI指导',
        aiPoweredCoachingDesc: '获取针对您目标量身定制的智能锻炼建议。',
        exerciseLibrary: '动作库',
        exerciseLibraryDesc: '访问数百种动作的详细指南。',
        nutritionGuidance: '营养指导',
        nutritionGuidanceDesc: '获取个性化餐饮建议和宏量计算。',
        workoutPlanning: '锻炼计划',
        workoutPlanningDesc: '为任何目标构建结构化训练计划。',
        availability: '全天候服务',
        availabilityDesc: '您的健身教练随时待命。',
        digitalTwins: '数字孪生',
        digitalTwinsDesc: '探索BUNKER，交互式了解每台机器能为您做什么。',
        
        // Chat
        aiPowered: 'AI驱动',
        yourAiCoach: '您的AI教练',
        chatSubtitle: '询问任何关于健身、营养或训练的问题。',
        gymBroAiCoach: 'GYM BRO AI教练',
        alwaysOnline: '始终在线 • 即时响应',
        online: '在线',
        tryAsking: '试着问:',
        tip1: '最佳胸部锻炼?',
        tip2: '如何减掉腹部脂肪?',
        tip3: '蛋白质摄入建议',
        tip4: '初学者锻炼计划',
        closeChat: '关闭',
        
        // CTA
        exercises: '动作',
        available: '可用',
        potential: '潜力',
        readyToTransform: '准备好改变了吗?',
        ctaSubtitle: '今天就与您的个人AI教练一起开始健身之旅。',
        startYourJourney: '开始您的旅程',
        
        // Footer
        allRightsReserved: '保留所有权利。',
        privacyPolicy: '隐私政策',
        termsOfService: '服务条款',
    },
    bg: {
        // Bulgarian
        home: 'Начало',
        features: 'Функции',
        aiCoach: 'AI Треньор',
        talkToAiCoach: 'Говори с AI Треньор',
        gymBro: 'GYM BRO',
        fitnessAndData: 'Фитнес и Данни',
        heroTagline: 'Вашият AI фитнес партньор. Получете персонализирани съвети, тренировъчни съвети и хранителни насоки — по всяко време.',
        startChatting: 'Започни чат',
        instantAnswers: 'Мигновени отговори',
        personalizedPlans: 'Персонализирани планове',
        featuresTitle: 'Всичко, от което се нуждаете',
        featuresSubtitle: 'Задвижван от усъвършенстван AI, за да ви даде най-добрите фитнес съвети.',
        aiPoweredCoaching: 'AI Коучинг',
        aiPoweredCoachingDesc: 'Получете интелигентни препоръки за тренировки, съобразени с вашите цели.',
        exerciseLibrary: 'Библиотека с упражнения',
        exerciseLibraryDesc: 'Достъп до подробни ръководства за стотици упражнения.',
        nutritionGuidance: 'Хранителни насоки',
        nutritionGuidanceDesc: 'Получете персонализирани предложения за хранене и изчисления на макроси.',
        workoutPlanning: 'Планиране на тренировки',
        workoutPlanningDesc: 'Изградете структурирани програми за тренировки.',
        availability: 'Достъпен 24/7',
        availabilityDesc: 'Вашият фитнес треньор е винаги готов, ден и нощ.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Разгледайте BUNKER и вижте какво може да направи всяка машина с вас интерактивно.',
        aiPowered: 'С AI',
        yourAiCoach: 'Вашият AI Треньор',
        chatSubtitle: 'Попитайте каквото и да е за фитнес, хранене или тренировки.',
        gymBroAiCoach: 'GYM BRO AI Треньор',
        alwaysOnline: 'Винаги онлайн • Мигновени отговори',
        online: 'Онлайн',
        tryAsking: 'Опитайте да попитате:',
        tip1: 'Най-добри упражнения за гърди?',
        tip2: 'Как да отслабна от корема?',
        tip3: 'Съвети за прием на протеин',
        tip4: 'План за начинаещи',
        closeChat: 'Затвори',
        exercises: 'Упражнения',
        available: 'Наличен',
        potential: 'Потенциал',
        readyToTransform: 'Готови ли сте за трансформация?',
        ctaSubtitle: 'Започнете вашето фитнес пътуване днес с вашия личен AI треньор.',
        startYourJourney: 'Започнете пътуването',
        allRightsReserved: 'Всички права запазени.',
        privacyPolicy: 'Политика за поверителност',
        termsOfService: 'Условия за ползване',
    },
    ro: {
        // Romanian
        home: 'Acasă',
        features: 'Funcții',
        aiCoach: 'Coach AI',
        talkToAiCoach: 'Vorbește cu Coach AI',
        gymBro: 'GYM BRO',
        fitnessAndData: 'Fitness și Date',
        heroTagline: 'Partenerul tău de fitness cu AI. Obține sfaturi personalizate, sfaturi de antrenament și ghidare nutrițională — oricând.',
        startChatting: 'Începe să conversezi',
        instantAnswers: 'Răspunsuri instantanee',
        personalizedPlans: 'Planuri personalizate',
        featuresTitle: 'Tot ce ai nevoie',
        featuresSubtitle: 'Alimentat de AI avansat pentru a-ți oferi cele mai bune sfaturi de fitness.',
        aiPoweredCoaching: 'Coaching AI',
        aiPoweredCoachingDesc: 'Obține recomandări inteligente de antrenament adaptate obiectivelor tale.',
        exerciseLibrary: 'Bibliotecă de exerciții',
        exerciseLibraryDesc: 'Acces la ghiduri detaliate pentru sute de exerciții.',
        nutritionGuidance: 'Ghidare nutrițională',
        nutritionGuidanceDesc: 'Primește sugestii de mese personalizate și calcule de macro.',
        workoutPlanning: 'Planificare antrenamente',
        workoutPlanningDesc: 'Construiește programe de antrenament structurate.',
        availability: 'Disponibil 24/7',
        availabilityDesc: 'Antrenorul tău de fitness este mereu gata, zi și noapte.',
        digitalTwins: 'Digital Twins',
        digitalTwinsDesc: 'Explorează BUNKER și vezi ce poate face fiecare mașină cu tine în mod interactiv.',
        aiPowered: 'Cu AI',
        yourAiCoach: 'Coach-ul tău AI',
        chatSubtitle: 'Întreabă orice despre fitness, nutriție sau antrenament.',
        gymBroAiCoach: 'GYM BRO Coach AI',
        alwaysOnline: 'Mereu online • Răspunsuri instantanee',
        online: 'Online',
        tryAsking: 'Încearcă să întrebi:',
        tip1: 'Cele mai bune exerciții pentru piept?',
        tip2: 'Cum să slăbesc din burtă?',
        tip3: 'Sfaturi pentru aport de proteine',
        tip4: 'Plan de antrenament pentru începători',
        closeChat: 'Închide',
        exercises: 'Exerciții',
        available: 'Disponibil',
        potential: 'Potențial',
        readyToTransform: 'Gata de transformare?',
        ctaSubtitle: 'Începe-ți călătoria fitness astăzi cu antrenorul tău personal AI.',
        startYourJourney: 'Începe călătoria',
        allRightsReserved: 'Toate drepturile rezervate.',
        privacyPolicy: 'Politica de confidențialitate',
        termsOfService: 'Termeni și condiții',
    },
    ar: {
        // Arabic
        home: 'الرئيسية',
        features: 'المميزات',
        aiCoach: 'مدرب AI',
        talkToAiCoach: 'تحدث مع مدرب AI',
        gymBro: 'GYM BRO',
        fitnessAndData: 'اللياقة والبيانات',
        heroTagline: 'شريكك في اللياقة البدنية بالذكاء الاصطناعي. احصل على نصائح مخصصة وإرشادات تغذوية في أي وقت.',
        startChatting: 'ابدأ المحادثة',
        instantAnswers: 'إجابات فورية',
        personalizedPlans: 'خطط مخصصة',
        featuresTitle: 'كل ما تحتاجه',
        featuresSubtitle: 'مدعوم بالذكاء الاصطناعي المتقدم لتقديم أفضل نصائح اللياقة.',
        aiPoweredCoaching: 'تدريب بالذكاء الاصطناعي',
        aiPoweredCoachingDesc: 'احصل على توصيات تمارين ذكية مصممة لأهدافك.',
        exerciseLibrary: 'مكتبة التمارين',
        exerciseLibraryDesc: 'الوصول إلى أدلة مفصلة لمئات التمارين.',
        nutritionGuidance: 'إرشادات التغذية',
        nutritionGuidanceDesc: 'احصل على اقتراحات وجبات مخصصة وحسابات الماكرو.',
        workoutPlanning: 'تخطيط التمارين',
        workoutPlanningDesc: 'بناء برامج تدريب منظمة.',
        availability: 'متاح 24/7',
        availabilityDesc: 'مدربك جاهز دائمًا، ليلاً ونهارًا.',
        digitalTwins: 'التوائم الرقمية',
        digitalTwinsDesc: 'استكشف BUNKER وشاهد ما يمكن لكل جهاز أن يفعله معك بشكل تفاعلي.',
        aiPowered: 'مدعوم بـ AI',
        yourAiCoach: 'مدربك AI',
        chatSubtitle: 'اسأل أي شيء عن اللياقة أو التغذية أو التدريب.',
        gymBroAiCoach: 'GYM BRO مدرب AI',
        alwaysOnline: 'متصل دائمًا • ردود فورية',
        online: 'متصل',
        tryAsking: 'جرب أن تسأل:',
        tip1: 'أفضل تمارين الصدر؟',
        tip2: 'كيف أخسر دهون البطن؟',
        tip3: 'نصائح البروتين',
        tip4: 'خطة تمارين للمبتدئين',
        closeChat: 'إغلاق',
        exercises: 'تمارين',
        available: 'متاح',
        potential: 'الإمكانات',
        readyToTransform: 'مستعد للتحول؟',
        ctaSubtitle: 'ابدأ رحلتك في اللياقة اليوم مع مدربك الشخصي AI.',
        startYourJourney: 'ابدأ رحلتك',
        allRightsReserved: 'جميع الحقوق محفوظة.',
        privacyPolicy: 'سياسة الخصوصية',
        termsOfService: 'شروط الخدمة',
    },
    ru: {
        // Russian
        home: 'Главная',
        features: 'Функции',
        aiCoach: 'AI Тренер',
        talkToAiCoach: 'Говорить с AI Тренером',
        gymBro: 'GYM BRO',
        fitnessAndData: 'Фитнес и Данные',
        heroTagline: 'Ваш AI фитнес-партнер. Получайте персонализированные советы, тренировочные рекомендации и руководство по питанию — в любое время.',
        startChatting: 'Начать чат',
        instantAnswers: 'Мгновенные ответы',
        personalizedPlans: 'Персональные планы',
        featuresTitle: 'Всё, что вам нужно',
        featuresSubtitle: 'На базе продвинутого AI для лучших фитнес-советов.',
        aiPoweredCoaching: 'AI Коучинг',
        aiPoweredCoachingDesc: 'Получите умные рекомендации по тренировкам, адаптированные к вашим целям.',
        exerciseLibrary: 'Библиотека упражнений',
        exerciseLibraryDesc: 'Доступ к подробным руководствам по сотням упражнений.',
        nutritionGuidance: 'Рекомендации по питанию',
        nutritionGuidanceDesc: 'Получите персонализированные рекомендации по питанию и расчёт макросов.',
        workoutPlanning: 'Планирование тренировок',
        workoutPlanningDesc: 'Создавайте структурированные программы тренировок.',
        availability: 'Доступен 24/7',
        availabilityDesc: 'Ваш фитнес-тренер всегда готов, днём и ночью.',
        digitalTwins: 'Цифровые двойники',
        digitalTwinsDesc: 'Исследуйте BUNKER и посмотрите, что каждый тренажёр может сделать с вами интерактивно.',
        aiPowered: 'На базе AI',
        yourAiCoach: 'Ваш AI Тренер',
        chatSubtitle: 'Спрашивайте что угодно о фитнесе, питании или тренировках.',
        gymBroAiCoach: 'GYM BRO AI Тренер',
        alwaysOnline: 'Всегда онлайн • Мгновенные ответы',
        online: 'Онлайн',
        tryAsking: 'Попробуйте спросить:',
        tip1: 'Лучшие упражнения на грудь?',
        tip2: 'Как убрать живот?',
        tip3: 'Советы по протеину',
        tip4: 'План для начинающих',
        closeChat: 'Закрыть',
        exercises: 'Упражнения',
        available: 'Доступно',
        potential: 'Потенциал',
        readyToTransform: 'Готовы к трансформации?',
        ctaSubtitle: 'Начните свой фитнес-путь сегодня с вашим персональным AI тренером.',
        startYourJourney: 'Начать путь',
        allRightsReserved: 'Все права защищены.',
        privacyPolicy: 'Политика конфиденциальности',
        termsOfService: 'Условия использования',
    },
};

// Detect user's browser language and return the best match
export const detectLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage || 'en';
    const langCode = browserLang.split('-')[0].toLowerCase();
    
    // Return the language if supported, otherwise default to English
    return translations[langCode] ? langCode : 'en';
};

// Get translations for current language
export const getTranslations = () => {
    const lang = detectLanguage();
    return translations[lang];
};

// Hook for using translations
export const useTranslations = () => {
    return getTranslations();
};
